import React from 'react';
import PropTypes from 'prop-types';

const Awards = ({ findOutMore, findOutMoreLink }) => {
  if (!findOutMore || !findOutMoreLink) {
    return null;
  }
  return (
    <div className="ft-awards">
      <div className="ft-awards__award ft-awards__award--1" />
      <div className="ft-awards__award ft-awards__award--2" />
      <a
        className="ft-awards__findOutMore"
        href={findOutMoreLink}
      >
        {findOutMore}
      </a>
    </div>
  );
};

Awards.propTypes = {
  findOutMore: PropTypes.string,
  findOutMoreLink: PropTypes.string,
};

export default Awards;
